import React from 'react';
import {LeaderboardItemType} from '../../types';
import FissionLeaderboardItem from './FissionLeaderboardItem';
import NoData from '@basicComponents/error-pages/no-data';

interface FissionLeaderboardListProps {
  data: LeaderboardItemType[];
}

const FissionLeaderboardList: React.FC<FissionLeaderboardListProps> = ({
  data,
}) => {
  return (
    <div className="bg-[#F2F2F2] rounded-tl-[30px] rounded-tr-[30px] z-10 relative">
      {/* Header */}
      <div className="flex items-center h-[2.875rem] px-5 justify-between text-sm text-[#575757] font-medium">
        <div className="text-left">Ranking</div>
        <div className="text-center">User Information</div>
        <div className="text-right">Estimated Amount</div>
      </div>

      {/* List Items */}
      <div className="space-y-1.5 mx-[15px] mt-3 pb-3">
        {data.slice(3).length > 0 ? (
          <>
            {data.slice(3).map((item, index) => (
              <FissionLeaderboardItem key={item.id || index} item={item} />
            ))}
          </>
        ) : (
          <NoData />
        )}
      </div>
      <div className="h-3"></div>
    </div>
  );
};

export default FissionLeaderboardList;
